export class ImobiliariaRequest {
    id: number;
    cpfCnpj: string;
    planoId: number;
    tagImobiliaria: string;

    constructor(p: any) {
        this.id = p.id !== undefined ? p.id : null;
        this.cpfCnpj = p.cpfCnpj !== undefined ? p.cpfCnpj : null;
        this.planoId = p.planoId !== undefined ? p.planoId : null;
        this.tagImobiliaria = p.tagImobiliaria !== undefined ? p.tagImobiliaria : null;
    }
}